import { render, staticRenderFns } from "./ChatFilter.vue?vue&type=template&id=50620a5c&"
import script from "./ChatFilter.vue?vue&type=script&lang=js&"
export * from "./ChatFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports